<template>
  <div>
    <h1 class="page-header">{{ $t('paymentannouncement.announcement') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{ $t('paymentannouncement.mainProgram') }}</label>
              <ts-search-select
                v-model.number="model.acp_id"
                :options="mainPrograms"
                @change="onMainProgramChange"
              ></ts-search-select>
              <small>
                <i>
                  {{
                    $t(
                      'paymentannouncement.chooseanymainprogramstodisplaysubprogramsand'
                    )
                  }}
                </i>
              </small>
            </div>
            <div class="form-group m-b-15">
              <label>
                {{ $t('paymentannouncement.subProgram') }}
                <span class="text-danger">*</span>
                <i class="fas fa-spinner spin" v-if="main_program_change"></i>
              </label>
              <ts-search-select
                v-model.number="model.acps_id"
                :disabled="main_program_change"
                :options="subPrograms"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>

            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.startDate')
              }}</label>
              <ts-date-picker-input v-model="model.start_date">
              </ts-date-picker-input>
              <div class="validate" v-if="errors.has('start_date')">
                {{ errors.first('start_date') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('paymentannouncement.endDate')
              }}</label>
              <ts-date-picker-input v-model="model.end_date">
              </ts-date-picker-input>
              <div class="validate" v-if="errors.has('end_date')">
                {{ errors.first('end_date') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label">{{
                $t('paymentannouncement.criteria')
              }}</label>
              <textarea
                rows="3"
                v-model="model.announcement_criteria"
                class="form-control"
                :class="{ 'is-invalid': errors.has('announcement_criteria') }"
                placeholder="Leave your criteria here..."
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('announcement_criteria')"
              >
                {{ errors.first('announcement_criteria') }}
              </div>
            </div>

            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table'
import moment from 'moment'
export default {
  name: 'payment-announcement-form',
  components: {
    DataTable
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      main_program_change: false,
      model: {
        acps_id: '',
        start_date: moment().format('DD-MM-YYYY'),
        end_date: moment().format('DD-MM-YYYY'),
        announcement_criteria: ''
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('paymentAnnouncement', ['edit_data']),
    mainPrograms() {
      return this.$store.state.paymentAnnouncement.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    subPrograms() {
      return this.$store.state.paymentAnnouncement.sub_programs.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    }
  },
  methods: {
    async onMainProgramChange() {
      if (!this.model.acp_id) {
        this.main_program_change = false
        return
      }
      this.main_program_change = true
      this.model.acps_id = ''
      await this.$store.dispatch(
        'paymentAnnouncement/getSubProgram',
        this.model.acp_id
      )
      this.main_program_change = false
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('paymentAnnouncement/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('paymentAnnouncement/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', {})
      this.$router.push({ name: 'payment-announcement' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('paymentAnnouncement/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.main_program_change = true
        await this.$store.dispatch(
          'paymentAnnouncement/getSubProgram',
          this.edit_data.acp_id
        )
        this.model = _.clone(this.edit_data)
        this.updating = true
        this.main_program_change = false
      }
    },
    clearInput() {
      this.model = {
        acps_id: '',
        start_date: moment().format('DD-MM-YYYY'),
        end_date: moment().format('DD-MM-YYYY'),
        announcement_criteria: ''
      }
    }
  },
  watch: {
    edit_data: {
      async handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('paymentAnnouncement/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
